/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   helpers.ts
 */

import { CarouselInternalState } from 'react-multi-carousel'

export const nextSlide =
  (
    currentSlide: CarouselInternalState['currentSlide'],
    totalItems: CarouselInternalState['totalItems'],
    goToSlide: (index: number) => void,
    next: (slidesHavePassed: number) => void
  ) =>
  (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    currentSlide === totalItems - 1 ? goToSlide(0) : next(1)
  }

export const previousSlide =
  (
    currentSlide: CarouselInternalState['currentSlide'],
    totalItems: CarouselInternalState['totalItems'],
    goToSlide: (index: number) => void,
    previous: (slidesHavePassed: number) => void
  ) =>
  (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    currentSlide === 0 ? goToSlide(totalItems - 1) : previous(1)
  }
